module.exports = __webpack_public_path__ + "static/media/bshare-256.b3e8d882.png";